// Permission action types
export const FETCH_PERMISSIONS_REQUEST = 'permissions/FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = 'permissions/FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = 'permissions/FETCH_PERMISSIONS_FAILURE';
export const ADD_PERMISSION_SUCCESS = 'permissions/ADD_PERMISSION_SUCCESS';
export const UPDATE_PERMISSION_SUCCESS = 'permissions/UPDATE_PERMISSION_SUCCESS';
export const DELETE_PERMISSION_SUCCESS = 'permissions/DELETE_PERMISSION_SUCCESS';
export const SET_EDITING_PERMISSION = 'permissions/SET_EDITING_PERMISSION';
export const CLEAR_EDITING_PERMISSION = 'permissions/CLEAR_EDITING_PERMISSION';
